import React from 'react';

const DocsHeroSection = () => {
  return (
    <section
      style={{
        minHeight: '100vh',
        width: '100%',
        position: 'relative',
        backgroundColor: '#242423',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0 1rem'
      }}
    >
      {/* Background Image Layer - Very Subtle */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: 'url(/assets/images/Documents-1770327873511.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center top',
          backgroundRepeat: 'no-repeat',
          opacity: 0.12,
          zIndex: 0
        }}
      />

      {/* Gradient Fade Overlay - Aggressive Fade */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'linear-gradient(to bottom, transparent 0%, rgba(36, 36, 35, 0.4) 30%, rgba(36, 36, 35, 0.8) 60%, #242423 85%)',
          zIndex: 1
        }}
      />

      {/* Existing Content - DO NOT MODIFY */}
      <div
        style={{
          position: 'relative',
          zIndex: 2,
          maxWidth: '80rem',
          margin: '0 auto',
          textAlign: 'center'
        }}
      >
        <h1 className="text-2xl font-bold text-foreground mb-6 max-w-4xl mx-auto">
          Documentation
        </h1>
        
        <p className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
          Everything you need to get started with Sleeve — from setup to advanced integrations.
        </p>
      </div>
    </section>
  );
};

export default DocsHeroSection;